module.exports = __webpack_public_path__ + "img/ico-checkmark-cicle.eb8dbb16.svg";